'use client';
import { NavGlow } from './assets/glow';
import { activeLinkClass, glowClass, linkClass, navListClass, navWrapperClass, } from './NavHeader.css';
import useGlow from './useGlow';
import classNames from 'classnames';
import React from 'react';
export const NavHeaderNavigation = ({ children, activeLink, }) => {
    const { glowX, animationDuration, glowRef, navRef, activeNav, setActiveNav } = useGlow(activeLink);
    return (React.createElement("nav", { className: navWrapperClass, ref: navRef },
        React.createElement("div", { className: glowClass, ref: glowRef, style: {
                transform: `translateX(${glowX}px)`,
                transitionDuration: `${animationDuration}ms`,
            } },
            React.createElement(NavGlow, null)),
        React.createElement("ul", { className: navListClass }, React.Children.map(children, (child, index) => (React.createElement("li", { key: `navItem-${index}`, onClick: () => setActiveNav(index + 1) }, React.cloneElement(child, {
            active: activeNav === index + 1,
            className: classNames(linkClass, {
                [activeLinkClass]: activeNav === index + 1,
                'nav-item': true,
            }),
        })))))));
};
//# sourceMappingURL=NavHeaderNavigation.js.map